import firebase from 'firebase';

// const settings = {timestampsInSnapshots: true};

const config = {
    apiKey: "AIzaSyA9D_YrEHze21_aaVkYuycSPVyv4upJsUY",
    authDomain: "smartmeter-1ab93.firebaseapp.com",
    databaseURL: "https://smartmeter-1ab93.firebaseio.com",
    projectId: "smartmeter-1ab93",
    storageBucket: "smartmeter-1ab93.appspot.com",
    messagingSenderId: "662346974260",
    appId: "1:662346974260:web:6982f1aeebbf9ca8a1f661"
};
firebase.initializeApp(config);

// firebase.firestore().settings(settings);

export default firebase;
